import React from "react";
import * as yup from "yup";
import {ListEditor} from "../../components/list-editor";
import {
    ExperientialType,
    ExperientialTypeQueryQuery,
    useExperientialTypeQueryQuery,
    useExperientialTypesMutationMutation
} from "../../generated/graphql";
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const columns = [{
    header: 'Name',
    accessor: 'name',
    dataType:'text'
}
];

function newRow():ExperientialType {
    return {
        id: uniqueId(),
        name: ''
    }
}

const schema =  yup.array().of(
        yup.object().shape({
        'name': yup.string().required()
    })
);

function getValues(data:ExperientialTypeQueryQuery):ExperientialType[] {
    return data?.experientialTypes??[];
}


function ExperientialTypes() {
    const query = useExperientialTypeQueryQuery();
    const [mutation,mutationResult] = useExperientialTypesMutationMutation();
    const url = useLocation().pathname;
    return (
        <ListEditor
            saveResult={mutationResult}
           columns={columns}
           validationSchema={schema}
            title="Experiential Types"
            mutation={mutation}
            query={query}
            permission="experientialtypes"
            newRow={newRow}
            newRowLabel="Add Experiential Type"
            baseUrl={url}
            getValues={getValues}
            className="experiential-types"
        />);
}

export default ExperientialTypes;
